import { bl_fi_item_label_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class FiItemCategoryImportFileHdrContainer extends BaseContainerModel {
  bl_fi_item_label_import_file_hdr: bl_fi_item_label_import_file_hdr_RowClass = new bl_fi_item_label_import_file_hdr_RowClass();
}
